import React, { useEffect, useState } from 'react';
import { MonedasAdapter } from '../../../../../infraestructure/persistence/rest/MonedasAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorMonedas from './selector';

export const SelectorMonedasContainer = (props: any) => {
	
	const api = new MonedasAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [monedas, setMonedas] = useState<any>([]);
	let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
	let result: any;
  
  useEffect(()=>{
	getMonedas();
  },[])

  useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions])

	const getMonedas = async () => {
		try {
			result = await api.ListarMonedas();
			if(result.data && result.data!=="")
			{
				setMonedas([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	return <SelectorMonedas {...{...props,...{selectedOptions:selectedOptions}}} options={monedas}/>

  //return <SelectorMonedas {...props} data={informes}/>
};

export default SelectorMonedasContainer;